import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import api from "../services/api";
import toast from "react-hot-toast";
import logoImg from "../assets/logo.png";
import "./Auth.css";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) return;
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (password !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", {
        token,
        password,
      });
      setDone(true);
      toast.success(data.message || "Password updated");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      toast.error(err.response?.data?.message || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page auth-page-split">
      <div className="auth-split-left">
        <div className="auth-lottie-wrap">
          <Player
            src="https://assets10.lottiefiles.com/packages/lf20_qp1q7mct.json"
            className="auth-lottie"
            autoplay
            loop
          />
        </div>
        <div className="auth-left-content">
          <h1 className="auth-left-title">IEO/SCS/ICD Task Management</h1>
          <p className="auth-left-tagline">Choose a new password for your account.</p>
        </div>
      </div>
      <div className="auth-split-right">
        <div className="auth-card auth-card-split">
          <div className="auth-logo-wrap">
            <img src={logoImg} alt="Logo" className="auth-logo" />
          </div>
          <h2 className="auth-title">Set new password</h2>
          <p className="auth-subtitle">
            {done
              ? "Redirecting to sign in…"
              : "Enter a new password below. The link from your email is valid for one hour."}
          </p>
          {!token && !done && (
            <p className="auth-subtitle" style={{ color: "#b45309" }}>
              Missing reset token. Open the link from your email, or request a new
              reset from{" "}
              <Link to="/forgot-password">Forgot password</Link>.
            </p>
          )}
          {!done && (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">New password</label>
                <input
                  className="form-control"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="At least 6 characters"
                  minLength={6}
                  required
                  disabled={!token}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm password</label>
                <input
                  className="form-control"
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Repeat password"
                  minLength={6}
                  required
                  disabled={!token}
                />
              </div>
              <button
                className="btn btn-primary auth-btn"
                type="submit"
                disabled={loading || !token}
              >
                {loading ? (
                  <span
                    className="spinner"
                    style={{ width: 18, height: 18, borderWidth: 2 }}
                  />
                ) : (
                  "Update password"
                )}
              </button>
            </form>
          )}
          <p className="auth-link">
            <Link to="/login">Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
